/**
 * Where the `paradigm` CLI should point, as the portal sees it.
 *
 * The CLI defaults to the production API, so on production the login line
 * needs no flag; anywhere else it needs `--api-base` on the very first command
 * or nothing after it works. CreateFlow and CliPage both build that line, so
 * both read it from here.
 */

/** The production API host. The CLI's default (cli/paradigm_cli/auth.py) and apiConfig.js's. */
export const PRODUCTION_API = 'https://api.ofself.com';
/** The old alias that still answers; the CLI needs no flag for it either. */
const PRODUCTION_ALIASES = [PRODUCTION_API, 'https://api.ofself.ai'];

/**
 * The API origin for a client base URL: `/api/v1` and trailing slashes dropped.
 * A relative base ("/api/v1" in local dev) means this page's own origin, which
 * proxies /api to the backend.
 */
export function cliApiBase(baseUrl) {
  let base = String(baseUrl || PRODUCTION_API).replace(/\/+$/, '').replace(/\/api\/v1$/, '');
  if (!/^https?:\/\//.test(base)) base = window.location.origin;
  return base.replace(/\/+$/, '');
}

/** The ` --api-base <origin>` flag the login line needs, or '' on production. */
export function cliApiBaseFlag(baseUrl) {
  const base = cliApiBase(baseUrl);
  return PRODUCTION_ALIASES.includes(base) ? '' : ` --api-base ${base}`;
}
